enum ProviderCountTypeEnum {
  InNetwork = "In Network",
  OutOfNetwork = "Out of Network",
}

export { ProviderCountTypeEnum };
